import { name } from "./";

const selectTotalUnreadNotifications = (state) => state[name].totalUnread;

export { selectTotalUnreadNotifications };
